import { createContext } from "react";
//for setting global Authication status

export const AuthContext = createContext(null);